import CustomerCreate from '_modules/customer/views/CustomerCreate.vue';
import CustomerEdit from '_modules/customer/views/CustomerEdit.vue';
import CustomerList from '_modules/customer/views/CustomerList.vue';
import Customer from './Root.vue';


export default {
  path: 'clientes/',
  component: Customer,
  name: 'admin-customer',
  redirect: '/clientes/lista/1',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-customer-lista',
      component: CustomerList,
    },
    {
      path: 'new/',
      name: 'admin-customer-new',
      component: CustomerCreate,
    },
    {
      path: ':customerId',
      name: 'admin-customer-edit',
      component: CustomerEdit,
    },
  ],
};
